import { Navigate, useLocation } from 'react-router-dom';
import Loader from './Loader';
import { useSupabaseAuth } from '../context/AuthContext';

export default function ProtectedRoute({ children }) {
  const { loading, isAuthenticated, isBlocked } = useSupabaseAuth();
  const location = useLocation();

  if (loading) return <Loader text="Checking your session..." />;
  if (!isAuthenticated) {
    const next = encodeURIComponent(`${location.pathname}${location.search || ''}`);
    return <Navigate to={`/auth?mode=signin&next=${next}`} replace />;
  }
  if (isBlocked && location.pathname !== '/blocked') {
    return <Navigate to="/blocked" replace />;
  }

  return children;
}
